/* ============================================================
   ILEV - CARRITO: colores del lanzamiento + popups del regalo
   ------------------------------------------------------------
   Lo carga snippets/cart-form.liquid con asset_url.
   Textos y foto del regalo: ILEV_CFG.modal (ilev-carrito-config.js)

   ⭐ DOS INTERRUPTORES PARA REVERTIR SIN TOCAR NADA MAS:

   AZUL = ''              -> el carrito vuelve al morado ILEV
   META_DESTACADA = false -> el popup vuelve al diseño anterior

   El bloque destacado del popup tiene dos modos, segun el config:
     - con ILEV_CFG.modal.okMetaMensaje -> modo AVISO (frase fija)
     - sin el                           -> modo CIFRA (cuanto falta)

   BARRA DEL CARRITO: la dibuja component-shipping-notice.js (v10)
   con hitos. Va LIMPIA sobre el blanco del carrito: sin franja de
   color y sin caja. Aqui solo se le pasan los colores del
   lanzamiento (relleno y hitos conseguidos en azul).

   VELOCIDAD: /cart/add.js tarda ~950 ms y /cart.js otros ~1100 ms
   en esta tienda. El popup se abre apenas responde el add y la
   venta cruzada se rellena despues.

   Este archivo NO repinta el carrito: solo pone estilos y
   reacciona a que el regalo entre o se repita. Nada de bucles.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window.ILEV_ACTIVO !== 'undefined' && !window.ILEV_ACTIVO) return;

  var AZUL       = '#3B5BE8';
  var META_DESTACADA = true;

  var AZUL_OSC   = '#2A44B8';
  var AZUL_SUAVE = '#EEF2FE';
  var AZUL_BORDE = '#C3CFFA';
  var TEXTO      = '#4B384C';
  var VERDE      = '#3f9e5c';
  var ACENTO     = AZUL || TEXTO;
  var CDN = 'https://cdn.shopify.com/s/files/1/0619/8296/5941/files/';

  function estilos() {
    var css =
      '.ilev-card__nr{color:' + TEXTO + '!important;font-size:10.5px!important;font-weight:500!important}' +
      '.ilev-badge{display:inline-block!important;width:auto!important;align-self:flex-start!important}' +

      '.ilev-pop{position:fixed;inset:0;z-index:100001;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(30,25,32,.62);opacity:0;transition:opacity .22s}' +
      '.ilev-pop--on{opacity:1}' +
      '.ilev-pop__box{position:relative;width:100%;max-width:410px;max-height:92vh;overflow-y:auto;background:#fff;border-radius:18px;padding:26px 22px 22px;text-align:center;box-shadow:0 18px 50px rgba(0,0,0,.3);transform:translateY(14px) scale(.98);transition:transform .24s}' +
      '.ilev-pop--on .ilev-pop__box{transform:none}' +
      '.ilev-pop__x{position:absolute;top:11px;right:12px;width:32px;height:32px;border:0;border-radius:50%;background:rgba(75,56,76,.08);color:' + TEXTO + ';font-size:18px;line-height:1;cursor:pointer;z-index:2}' +
      '.ilev-pop__x:hover{background:rgba(75,56,76,.16)}' +
      '.ilev-pop__ico{width:88px;height:88px;margin:0 auto 14px;border-radius:50%;background:' + AZUL_SUAVE + ';display:flex;align-items:center;justify-content:center;overflow:hidden;font-size:34px}' +
      '.ilev-pop__ico img{width:100%;height:100%;object-fit:contain;padding:7px;display:block}' +
      '.ilev-pop__k{margin:0 0 5px;font-size:11px;font-weight:700;letter-spacing:1.2px;text-transform:uppercase;color:rgba(75,56,76,.6)}' +
      '.ilev-pop__t{margin:0 0 9px;font-size:23px;line-height:1.2;color:' + TEXTO + '}' +
      '.ilev-pop__p{margin:0 0 10px;font-size:14.5px;line-height:1.5;color:rgba(75,56,76,.85)}' +

      '.ilev-pop__prog{margin:0 0 6px;font-size:13px;line-height:1.4;color:' + TEXTO + '}' +
      '.ilev-pop__meta{margin:0 0 16px;padding:15px 16px 14px;border-radius:14px;background:' + AZUL_SUAVE + ';border:1px solid ' + AZUL_BORDE + '}' +
      '.ilev-pop__meta-k{display:block;font-size:11px;font-weight:700;letter-spacing:1.1px;text-transform:uppercase;line-height:1.2;color:rgba(75,56,76,.6)}' +
      '.ilev-pop__meta-n{display:block;font-size:27px;line-height:1.15;font-weight:800;color:' + AZUL + ';letter-spacing:-.6px;margin:1px 0 3px}' +
      '.ilev-pop__meta-t{display:block;font-size:13px;line-height:1.35;color:' + TEXTO + ';margin-bottom:12px}' +
      '.ilev-pop__meta-m{margin:7px 0 13px;font-size:16px;line-height:1.35;font-weight:500;color:' + TEXTO + '}' +
      '.ilev-pop__meta-m strong{font-weight:800;color:' + AZUL + '}' +
      '.ilev-pop__meta--ok{background:#eefaf1;border-color:#9fd8b0}' +
      '.ilev-pop__meta--ok .ilev-pop__meta-n{font-size:19px;color:' + VERDE + '}' +
      '.ilev-pop__meta--ok .ilev-pop__meta-m strong{color:' + VERDE + '}' +
      '.ilev-pop__riel{height:' + (META_DESTACADA ? '9' : '7') + 'px;' + (META_DESTACADA ? '' : 'margin-bottom:15px;') + 'background:rgba(59,91,232,.16);border-radius:99px;overflow:hidden}' +
      '.ilev-pop__riel span{display:block;height:100%;background:' + ACENTO + ';border-radius:99px;transition:width .5s}' +
      '.ilev-pop__meta--ok .ilev-pop__riel span{background:' + VERDE + '}' +

      (META_DESTACADA
        ? '.ilev-pop__envio{margin:0 0 16px;padding:0;background:none;border:0;font-size:13px;line-height:1.45;color:rgba(75,56,76,.7)}'
        : '.ilev-pop__envio{margin:0 0 16px;padding:12px 14px;border-radius:12px;background:' + AZUL_SUAVE + ';border:1px solid ' + AZUL_BORDE + ';font-size:13.5px;line-height:1.45;color:' + TEXTO + '}') +

      '.ilev-pop__ct{margin:16px 0 9px;font-size:11px;font-weight:700;letter-spacing:.8px;text-transform:uppercase;color:rgba(75,56,76,.6);text-align:left}' +
      '.ilev-pop__lista{display:flex;flex-direction:column;gap:7px;margin-bottom:16px}' +
      '.ilev-pop__c{display:flex;gap:9px;align-items:center;padding:8px;border:1px solid rgba(75,56,76,.14);border-radius:11px;text-align:left}' +
      '.ilev-pop__c img{width:44px;height:44px;object-fit:contain;border-radius:7px;background:#f7fbfc;flex:0 0 44px}' +
      '.ilev-pop__ci{flex:1;min-width:0}' +
      '.ilev-pop__cn{display:block;font-size:12.5px;font-weight:600;color:' + TEXTO + ';line-height:1.25}' +
      '.ilev-pop__cp{display:block;font-size:12px;color:rgba(75,56,76,.7)}' +
      '.ilev-pop__cok{display:block;font-size:10.5px;font-weight:600;color:' + VERDE + '}' +
      '.ilev-pop__add{flex:0 0 30px;width:30px;height:30px;border:0;border-radius:50%;background:' + ACENTO + ';color:#fff;font-size:18px;line-height:1;cursor:pointer}' +
      '.ilev-pop__add[disabled]{opacity:.45}' +
      '.ilev-pop__cargando{height:64px;display:flex;align-items:center;justify-content:center}' +
      '.ilev-pop__cargando span{width:7px;height:7px;margin:0 3px;border-radius:50%;background:rgba(75,56,76,.28);display:inline-block;animation:ilevPunto 1s ease-in-out infinite}' +
      '.ilev-pop__cargando span:nth-child(2){animation-delay:.15s}' +
      '.ilev-pop__cargando span:nth-child(3){animation-delay:.3s}' +
      '@keyframes ilevPunto{0%,100%{opacity:.28}50%{opacity:.9}}' +
      '.ilev-pop__btns{display:flex;flex-direction:column;gap:8px}' +
      '.ilev-pop__b{display:block;width:100%;padding:14px 18px;border:0;border-radius:99px;font-family:inherit;font-size:14.5px;font-weight:700;cursor:pointer;line-height:1.25;text-decoration:none;box-sizing:border-box}' +
      '.ilev-pop__b--p{background:' + ACENTO + ';color:#fff}' +
      '.ilev-pop__b--p:hover{background:' + AZUL_OSC + '}' +
      '.ilev-pop__b--s{background:#fff;color:' + TEXTO + ';border:1px solid rgba(75,56,76,.25)}' +
      '.ilev-pop__b--s:hover{background:#f7f7f8}' +
      '@media(max-width:420px){.ilev-pop__t{font-size:21px}.ilev-pop__box{padding:24px 17px 18px}.ilev-pop__b{font-size:13.5px}.ilev-pop__meta-n{font-size:25px}.ilev-pop__meta-m{font-size:15px}}' +
      '@media(prefers-reduced-motion:reduce){.ilev-pop,.ilev-pop__box{transition:none}}';

    if (AZUL) {
      css +=
        /* ========================================================
           BARRA DEL CARRITO: limpia, sin franja de color ni caja.
           Solo se le pasan los colores del lanzamiento.
           ======================================================== */
        '#site-cart-sidebar shipping-notice.cart-notice{background:transparent!important}' +
        '.ilev-prog,.ilev-prog--h,.ilev-prog--casi,.ilev-prog--ok{background:transparent!important;border:0!important;box-shadow:none!important;padding:4px 2px 0!important}' +
        '.ilev-prog__txt{color:' + TEXTO + '!important;margin-bottom:16px!important}' +
        '.ilev-prog__txt::after{content:none!important}' +
        '.ilev-prog__riel{background:rgba(75,56,76,.10)!important}' +
        '.ilev-prog__riel span{background:' + AZUL + '!important}' +
        /* la barra con hitos */
        '.ilev-hitos{height:84px!important}' +
        '.ilev-hitos__riel{background:rgba(75,56,76,.10)!important}' +
        '.ilev-hitos__fill{background:' + AZUL + '!important}' +
        '.ilev-hito__ico{box-shadow:0 0 0 3px #fff!important}' +
        '.ilev-hito--on .ilev-hito__ico{background:' + AZUL + '!important;color:#fff!important}' +
        '.ilev-hito--on .ilev-hito__n,.ilev-hito--on .ilev-hito__p{color:' + AZUL_OSC + '!important}' +

        '.ilev-badge{background:' + AZUL + '!important}' +
        '.ilev-add{background:' + AZUL + '!important}' +
        '.ilev-aviso{background:' + AZUL + '!important}' +

        '#site-cart-sidebar #ViewCart{display:none!important}' +
        '#site-cart-sidebar .flex-buttons{display:block!important}' +
        '#site-cart-sidebar #CheckOut{display:block!important;width:100%!important;background:' + AZUL + '!important;border-color:' + AZUL + '!important;color:#fff!important;font-weight:700!important}' +
        '#site-cart-sidebar #CheckOut:hover{background:' + AZUL_OSC + '!important;border-color:' + AZUL_OSC + '!important}';
    }

    var s = document.createElement('style');
    s.id = 'ilev-ajustes';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function arrancar() {
    var CFG = window.ILEV_CFG;
    var VID = CFG.regaloVariantId, MAX = CFG.maxRegalo || 1, T = CFG.modal || {};
    var UMBRAL = (CFG.umbral || 40000) * 100, ENVIO = CFG.despacho || 4500;
    var abierto = false, ultimo = 0;

    function pesos(c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); }
    function miles(v) { return '$' + v.toLocaleString('es-CL'); }
    function cart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
    function icono() { return T.imagen ? '<img src="' + T.imagen + '" alt="Shampoo Anticaspa Viajero 30 g">' : '🎁'; }

    function cerrar() {
      var p = document.getElementById('ilev-pop');
      if (!p) { abierto = false; return; }
      p.classList.remove('ilev-pop--on');
      setTimeout(function () { if (p.parentNode) p.remove(); abierto = false; }, 220);
    }

    function irAlCarrito() {
      var h = document.querySelector('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]');
      cerrar();
      if (h) setTimeout(function () { h.click(); }, 240);
      else window.location.href = '/cart';
    }

    function sugerencias(c) {
      var ids = c.items.map(function (i) { return i.variant_id; });
      var tiene = function (id) { return ids.indexOf(id) !== -1; };
      var out = [];
      if (typeof window.ILEV_REGLA === 'function' && window.ILEV_IDS) {
        (window.ILEV_REGLA(tiene, window.ILEV_IDS) || []).forEach(function (id) {
          var p = CFG.productos && CFG.productos[id];
          if (p) out.push({ id: id, n: p.n, p: p.p, img: p.img });
        });
      }
      (CFG.extras || []).forEach(function (e) { if (!tiene(e.id)) out.push(e); });
      return out.slice(0, 3);
    }

    function htmlCruce(c) {
      var sub = c.items_subtotal_price, falta = UMBRAL - sub, ok = falta <= 0;
      var pct = ok ? 100 : Math.max(4, Math.round((sub / UMBRAL) * 100));
      var h;

      if (META_DESTACADA) {
        if (ok) {
          h = '<div class="ilev-pop__meta ilev-pop__meta--ok">' +
                '<strong class="ilev-pop__meta-n">' + (T.okMetaListo || '¡Tienes envío gratis!') + '</strong>' +
                '<span class="ilev-pop__meta-t">' + (T.okMetaListoTexto || 'No pagas despacho') + '</span>' +
                '<div class="ilev-pop__riel"><span style="width:100%"></span></div>' +
              '</div>';
        } else if (T.okMetaMensaje) {
          h = '<div class="ilev-pop__meta">' +
                (T.okMetaKicker ? '<span class="ilev-pop__meta-k">' + T.okMetaKicker + '</span>' : '') +
                '<p class="ilev-pop__meta-m">' + T.okMetaMensaje.replace('{umbral}', miles(CFG.umbral || 40000)) + '</p>' +
                '<div class="ilev-pop__riel"><span style="width:' + pct + '%"></span></div>' +
              '</div>';
        } else {
          h = '<div class="ilev-pop__meta">' +
                '<span class="ilev-pop__meta-k">' + (T.okMetaKicker || 'Te faltan') + '</span>' +
                '<strong class="ilev-pop__meta-n">' + pesos(falta) + '</strong>' +
                '<span class="ilev-pop__meta-t">' + (T.okMetaTexto || '').replace('{envio}', miles(ENVIO)) + '</span>' +
                '<div class="ilev-pop__riel"><span style="width:' + pct + '%"></span></div>' +
              '</div>';
        }
      } else {
        var txt = ok ? (T.okCruceListo || '') : (T.okCruceFalta || '').replace('{falta}', pesos(falta));
        h = '<p class="ilev-pop__prog">' + txt + '</p>' +
            '<div class="ilev-pop__riel"><span style="width:' + pct + '%"></span></div>';
      }

      var lista = sugerencias(c);
      if (!lista.length) return h;
      h += '<p class="ilev-pop__ct">' + (T.okCruceTitulo || '') + '</p><div class="ilev-pop__lista">';
      lista.forEach(function (s) {
        var cruza = !ok && (sub + s.p * 100) >= UMBRAL;
        var img = s.img ? '<img src="' + CDN + s.img + '" alt="" loading="lazy">' : '<span style="flex:0 0 44px"></span>';
        h += '<div class="ilev-pop__c">' + img +
             '<span class="ilev-pop__ci"><span class="ilev-pop__cn">' + s.n + '</span>' +
             '<span class="ilev-pop__cp">' + miles(s.p) + '</span>' +
             (cruza ? '<span class="ilev-pop__cok">Con este te llega el envio gratis</span>' : '') +
             '</span><button type="button" class="ilev-pop__add" data-v="' + s.id + '" aria-label="Agregar ' + s.n + '">+</button></div>';
      });
      return h + '</div>';
    }

    function abrir(tipo, c, texto) {
      var ahora = Date.now();
      if (abierto || (ahora - ultimo) < 900) return;
      ultimo = ahora; abierto = true;

      var urlSeguir = T.okBtnSeguirUrl || '';
      var btnRutina = urlSeguir
        ? '<a class="ilev-pop__b ilev-pop__b--p" href="' + urlSeguir + '">' + (T.okBtnSeguir || 'Seguir viendo') + '</a>'
        : '<button type="button" class="ilev-pop__b ilev-pop__b--p" data-cerrar>' + (T.okBtnSeguir || 'Seguir viendo') + '</button>';
      var btnCarrito = '<button type="button" class="ilev-pop__b ilev-pop__b--s" data-ir>' + (T.okBtnCarrito || 'Ir a mi carrito') + '</button>';
      var espera = '<div class="ilev-pop__cargando"><span></span><span></span><span></span></div>';

      var cuerpo = (tipo === 'ok')
        ? '<div class="ilev-pop__ico">' + icono() + '</div>' +
          '<p class="ilev-pop__k">' + (T.okKicker || '') + '</p>' +
          '<h2 class="ilev-pop__t">' + (T.okTitulo || '') + '</h2>' +
          '<p class="ilev-pop__p">' + (T.okTexto || '') + '</p>' +
          '<p class="ilev-pop__envio">' + (T.okEnvio || '').replace('{envio}', miles(ENVIO)) + '</p>' +
          '<div data-cruce>' + (c ? htmlCruce(c) : espera) + '</div>' +
          '<div class="ilev-pop__btns">' + btnRutina + btnCarrito + '</div>'
        : '<div class="ilev-pop__ico">' + icono() + '</div>' +
          '<p class="ilev-pop__k">' + (T.topeKicker || '') + '</p>' +
          '<h2 class="ilev-pop__t">' + (T.topeTitulo || '') + '</h2>' +
          '<p class="ilev-pop__p">' + (texto || T.topeTexto || '') + '</p>' +
          '<div class="ilev-pop__btns">' +
            '<button type="button" class="ilev-pop__b ilev-pop__b--p" data-ir>' + (T.topeBtnCarrito || 'Ver mi carrito') + '</button>' +
            '<button type="button" class="ilev-pop__b ilev-pop__b--s" data-cerrar>' + (T.topeBtn || 'Entendido') + '</button>' +
          '</div>';

      var p = document.createElement('div');
      p.id = 'ilev-pop'; p.className = 'ilev-pop';
      p.setAttribute('role', 'dialog'); p.setAttribute('aria-modal', 'true');
      p.innerHTML = '<div class="ilev-pop__box"><button type="button" class="ilev-pop__x" data-cerrar aria-label="Cerrar">✕</button>' + cuerpo + '</div>';
      document.body.appendChild(p);
      requestAnimationFrame(function () { p.classList.add('ilev-pop--on'); });

      if (tipo === 'ok' && !c) {
        cart().then(function (cc) {
          var z = document.querySelector('#ilev-pop [data-cruce]');
          if (z) z.innerHTML = htmlCruce(cc);
        }).catch(function () {
          var z = document.querySelector('#ilev-pop [data-cruce]');
          if (z) z.innerHTML = '';
        });
      }

      p.addEventListener('click', function (e) {
        if (e.target.closest('a[href]')) return;
        if (e.target === p || e.target.closest('[data-cerrar]')) { cerrar(); return; }
        if (e.target.closest('[data-ir]')) { irAlCarrito(); return; }
        var add = e.target.closest('.ilev-pop__add');
        if (add) {
          add.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(add.dataset.v), quantity: 1 }] })
          }).then(function () {
            if (typeof window.refreshCart === 'function') window.refreshCart();
            document.dispatchEvent(new CustomEvent('cart-updated'));
            irAlCarrito();
          }).catch(function () { add.disabled = false; });
        }
      });

      document.addEventListener('keydown', function esc(e) {
        if (e.key === 'Escape') { cerrar(); document.removeEventListener('keydown', esc); }
      });
    }

    window.ILEV_POPUP = {
      ok: function () { abrir('ok', null); },
      tope: function () { abrir('tope'); },
      cerrar: cerrar
    };

    var f0 = window.fetch;
    window.fetch = function () {
      var u = arguments[0], init = arguments[1], pide = false;
      try {
        var url = (typeof u === 'string') ? u : (u && u.url) || '';
        if (url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string' &&
            init.body.indexOf(String(VID)) !== -1) pide = true;
      } catch (e) {}
      return f0.apply(this, arguments).then(function (r) {
        if (pide && r.ok) {
          r.clone().json().then(function (d) {
            var it = (d && d.items && d.items[0]) ? d.items[0] : d;
            var q = it && it.quantity ? it.quantity : 1;
            if (q > MAX) abrir('tope');
            else abrir('ok', null);
          }).catch(function () {});
        }
        return r;
      });
    };

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].addedNodes;
        for (var j = 0; j < n.length; j++) {
          if (n[j].id === 'ilev-aviso') {
            var txt = n[j].textContent || '';
            n[j].remove();
            abrir('tope', null, txt);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  estilos();

  function esperar(n) {
    if (window.ILEV_POPUP) return;
    if (window.ILEV_CFG && window.ILEV_CFG.regaloVariantId) { arrancar(); return; }
    if (n <= 0) return;
    setTimeout(function () { esperar(n - 1); }, 100);
  }
  esperar(80);

})();
